export default {"src":"/_next/static/media/check.89cf1953.svg","height":8,"width":11};